export default __webpack_public_path__ + "static/media/importerMenuIcon.ec70c5e0.svg";